import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import { FormProvider, useForm } from 'react-hook-form'
import {
  DialogActions,
  DialogContent, DialogContentText,
  DialogTitle,
  Grid,
  TextField, Typography
} from '@mui/material'
import SubmitButton from '../../commonUIComponents/SubmitButton'
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import updateEmailAddressService from '../../../services/updateEmailAddressService'
import userService from '../../../services/userService'

const UpdateAccountEmailModal = ({ methods, open, onClose, onNext }) => {
  const { enqueueSnackbar } = useSnackbar()
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = methods

  const submitHandler = values => {
    const formValues = { password: values.password }
    return userService.verifyPassword(formValues)
      .then(() => onNext())
      .catch(err => enqueueSnackbar(err?.response?.data?.message, { variant: 'warning' }))
  }

  return (
    <>
      {open
        ? (
          <Dialog
            open={open}
            onClose={onClose}
          >
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(submitHandler)}>
                <Grid container>
                  <Grid item xs={12}>
                    <DialogTitle>Verify your password</DialogTitle>
                  </Grid>
                  <Grid item xs={12}>
                    <DialogContent sx={{ mt: '-1rem' }}>
                      <TextField
                        label="Password"
                        type="password"
                        {...register('password',
                          {
                            required: {
                              value: true,
                              message: 'Invalid Password'
                            }
                          }
                        )}
                        error={errors.password}
                        helperText={errors.passwword?.message}
                        margin="dense"
                        fullWidth
                      />
                    </DialogContent>
                  </Grid>
                </Grid>
                <IconButton
                  aria-label="close"
                  onClick={onClose}
                  sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500]
                  })}
                >
                  <CloseIcon/>
                </IconButton>
                <DialogActions>
                  <SubmitButton buttonLabel="Continue" textAlign="right"/>
                </DialogActions>
              </form>
            </FormProvider>
          </Dialog>
          )
        : undefined
      }
    </>
  )
}

export default UpdateAccountEmailModal
